import Dbm from "dbm";
import Website from "../../../index.js";

export default class Coin extends Dbm.core.BaseObject {
    _construct() {
        super._construct();

        let container = new PIXI.Container();
        this.item.setValue("pixiLayer", container);
        this.item.setValue("sprite", null);
        this.item.setValue("speed", 0);

        this.item.setValue("x", 0);
        this.item.setValue("y", 0);
        this.item.setValue("animationOffset", 0);
        this.item.setValue("amplitude", 2);

        let radius = 6;

        const body = Matter.Bodies.circle(0, 0, radius, {
            isSensor: true,
            isStatic: true,
            label: this._getLabel(),
            collisionFilter: Website.game.PhysicsGroups.createCollisionFilter(Website.game.PhysicsGroups.COINS, Website.game.PhysicsGroups.COINS_INTERACTIONS)
        });
        
        this.item.setValue("physicsBody", body);
    }

    _getLabel() {
        return "coin";
    }

    setSprite(aSprite) {
        this.item.sprite = aSprite;
        this.item.pixiLayer.addChild(aSprite);

        return this;
    }

    setIntialPosition(aCameraPosition) {
        let currentPosition = this.item.physicsBody.position;

        let x = this.item.x - aCameraPosition + Website.game.Sizes.CENTER_X;

        Matter.Body.setPosition(this.item.physicsBody, {
            x: x,
            y: this.item.y
        });
    }

    update(aCameraPosition, aTime, aDelta) {
        //console.log("update");

        const FLOAT_SPEED = 2*Math.PI;

        if(this.item.speed) {
            this.item.x -= this.item.speed*aDelta;
        }

        let x = this.item.x - aCameraPosition + Website.game.Sizes.CENTER_X;

        Matter.Body.setPosition(this.item.physicsBody, {
            x: x,
            y: this.item.y + Math.sin(FLOAT_SPEED*aTime + Math.PI*this.item.animationOffset) * this.item.amplitude
        });

        this.item.pixiLayer.x = this.item.physicsBody.position.x;
        this.item.pixiLayer.y = this.item.physicsBody.position.y+(Website.game.Sizes.GROUND_POSITION+Website.game.Sizes.PLAYER_POSITION);

       //console.log(this.item.pixiLayer.x, this.item.pixiLayer.y);
    }
}